import Analytics from '@withlocals/withlocals-analytics';
import { Translator } from 'Translator';
import Card from 'components/Card';
import LazyImage from 'components/LazyImage';
import LocalizedLink from 'components/LocalizedLink';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { WlWindow } from 'typings/globals/cordova';

import PassionArtwork from './PassionArtwork';

const CSS = require('./PassionCategoryCard.less');

declare const window: WlWindow;

interface PassionCategoryCardProps {
  area?: string;
  name: string;
  text: string;
  image: string;
  url: string;
  hide: boolean;
}

const TEXT_LIMIT = 40;
const INVIEW_OPTIONS = { triggerOnce: true, threshold: 0.4, delay: 100 };
const IMAGE_OPTIONS = { width: 216, height: 352 };

function getLimit(text) {
  let limit = TEXT_LIMIT;
  if (limit >= text.length) {
    return text.length;
  }

  while (text.charAt(limit) !== ' ' && limit < text.length) {
    limit += 1;
  }
  return limit;
}

function PassionCategoryCard({
  area = 'Withlocals',
  name,
  text,
  image,
  url,
  hide,
}: PassionCategoryCardProps) {
  const onClick = () =>
    Analytics.track(
      window.currentPageCategory,
      'Select passion category',
      name,
    );
  const { ref, inView } = useInView(INVIEW_OPTIONS);

  useEffect(() => {
    if (inView) {
      Analytics.track(
        window.currentPageCategory,
        'View passion category card',
        name,
      );
    }
  }, [inView, name]);

  if (hide) {
    return null;
  }

  const textLimit = getLimit(text);

  return (
    <Card as="li" className={CSS.Card} ref={ref}>
      <figure className={CSS.Figure}>
        <LazyImage
          animate
          src={image}
          options={IMAGE_OPTIONS}
          width={IMAGE_OPTIONS.width}
          height={IMAGE_OPTIONS.height}
          containerClass={CSS.ImageContainer}
          alt={text}
          className={CSS.Image}
          draggable={false}
          forceInView
        />
      </figure>
      <div className={CSS.Content}>
        <p className={CSS.TextTop}>
          {Translator.translateText(
            'SearchPage.PassionCategoryCard.topText',
            { area: area || 'Withlocals' },
            '{area} for',
          )}
        </p>
        <span className={CSS.ArtworkContainer}>
          <PassionArtwork name={name} inView={inView} />
        </span>
        <p className={CSS.TextBottom}>
          {text.substring(0, textLimit)}
          {text.length >= textLimit ? '...' : ''}{' '}
        </p>
        <LocalizedLink
          className={CSS.ExploreButton}
          to={url}
          onClick={onClick}
          rel="nofollow"
        >
          {Translator.translateText('Common.Button.explore', {}, 'Explore')}
        </LocalizedLink>
      </div>
    </Card>
  );
}

export default PassionCategoryCard;
